
import { useEffect, type ReactNode } from "react";
import { I18nextProvider } from "react-i18next";

import i18n, { detectLocale, LOCALE_STORAGE_KEY, isAdminLocale } from "./i18n";

function syncDocumentLanguage(language: string) {
  if (isAdminLocale(language)) document.documentElement.lang = language;
}

export function I18nProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const detected = detectLocale();
    if (i18n.language !== detected) void i18n.changeLanguage(detected);
    syncDocumentLanguage(detected);

    const onStorage = (event: StorageEvent) => {
      if (event.key !== LOCALE_STORAGE_KEY) return;
      const next = isAdminLocale(event.newValue) ? event.newValue : detectLocale();
      if (i18n.language !== next) void i18n.changeLanguage(next);
    };
    i18n.on("languageChanged", syncDocumentLanguage);
    window.addEventListener("storage", onStorage);
    return () => {
      i18n.off("languageChanged", syncDocumentLanguage);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export function setAdminLocale(locale: string) {
  if (!isAdminLocale(locale)) return;
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {}
  void i18n.changeLanguage(locale);
}
